<template>
  <div>
    <section v-if="data.length">
      <div id="projects" class="section">
        <div>
          <transition appear @before-enter="beforeEnterH1" @enter="enterH1">
            <h1>{{ "" }}</h1>
          </transition>
          <WebProjects
            :beforeEnterBox="beforeEnterBox"
            :beforeEnter="beforeEnter"
            :enterBox="enterBox"
            :enter="enter"
            :projects="
              data.filter(
                (project) =>
                  project.homepage && project.name !== 'LahoucineABOULHASSAN'
              )
            "
          />
          <br />
          <OtherProjects
            :beforeEnterBox="beforeEnterBox"
            :beforeEnter="beforeEnter"
            :enterBox="enterBox"
            :enter="enter"
            :projects="
              data.filter(
                (project) =>
                  !project.homepage && project.name !== 'LahoucineABOULHASSAN'
              )
            "
          />
        </div>
      </div>
    </section>
    <Error
      v-if="error"
      :error="error"
      :beforeEnter="beforeEnter"
      :enter="enter"
    />
  </div>
</template>
<script>
import WebProjects from "./projects/WebProjects";
import OtherProjects from "./projects/OtherProjects";
import getData from "../composables/getData";
import gsapAnimation from "../composables/gsapAnimation";
import { Error } from "../components";
export default {
  components: { WebProjects, OtherProjects, Error },
  setup() {
    const { data, error, fetchData } = getData(process.env.VUE_APP_REPOS_URL);
    const {
      beforeEnter,
      enter,
      beforeEnterH1,
      enterH1,
      beforeEnterBox,
      enterBox,
    } = gsapAnimation({
      h1: "My Projects",
      y: "100%",
      ease: "back",
    });
    fetchData();
    return {
      data,
      error,
      fetchData,
      beforeEnter,
      enter,
      beforeEnterH1,
      enterH1,
      beforeEnterBox,
      enterBox,
    };
  },
};
</script>
<style>
#projects div div > h2 {
  padding: 7px 15px;
  font-size: 18px;
  text-transform: uppercase;
  letter-spacing: 5px;
  font-weight: 600;
  border-radius: 5px;
}
#projects div div:hover > h2 {
  padding-left: 50px;
  padding-right: 50px;
}
#projects img {
  width: 100%;
  height: 100%;
}
#projects .box div {
  width: 100%;
}
#projects .flex-row {
  justify-content: space-between;
}
#projects span.flex-row {
  padding: 0.85rem 0;
  border-top: 1px solid var(--grey);
}
#projects .box div {
  padding: 0 1rem;
}
#projects div .box {
  margin: 1rem 0;
  color: var(--grey);
  border-radius: 5px;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
}
#projects small {
  text-transform: capitalize;
  display: block;
  color: #c0c0c0c0;
  font-weight: bold;
}
#projects h4 {
  color: var(--blue);
  text-transform: capitalize;
}
#projects h4 a {
  color: var(--blue);
  text-transform: capitalize;
}
#projects p {
  margin: 0.25rem 0;
}
#projects button.read-more {
  float: right;
  margin-bottom: 0.5rem;
}
#projects small .btn-link,
#projects .show-all {
  padding: 0.3rem 0.5rem;
  color: var(--dark);
}
#projects .show-all {
  background: #e6394694;
  border-radius: 5px;
}
#projects .show-all:hover {
  background: #e63946d1;
}
#projects small:nth-child(1) .btn-link {
  background: #81d9aa;
}
#projects small:nth-child(2) .btn-link {
  background: #fac975;
}
#projects small:nth-child(1) .btn-link:hover {
  background: #52cb8b;
}
#projects small:nth-child(2) .btn-link:hover {
  background: #f9b339;
}
#projects i.icon {
  opacity: 0.8;
}
</style>
